<menu-bar [displayOptions]="_activeTab | equals: 2 | not" [displayMainOptions]="_activeTab | equals: 0"></menu-bar>
<tab-view-container></tab-view-container>
<footer-bar></footer-bar>